// src/hooks/useVoice.ts
import { useEffect } from 'react';
import voiceService from '../../services/voiceService';

export const useVoice = ({
  language = 'en',
  inputLanguage = 'en',
  setTextAreaValue,
  setIsRecordingInProcess,
  isTrascribe = false,
  setRunOnValue,
}: {
  language?: string;
  inputLanguage?: string;
  setTextAreaValue: (value: string, isTranslated?: boolean) => void;
  setIsRecordingInProcess?: (isRecording: boolean) => void;
  isTrascribe?: boolean;
  setRunOnValue?: (subtitles: string[]) => void;
}) => {
  // Configure the voice service with the provided parameters
  useEffect(() => {
    voiceService.configure({
      language,
      inputLanguage,
      setTextAreaValue,
      setIsRecordingInProcess,
      isTranscribe: isTrascribe,
      setRunOnValue,
    });
  }, [language, inputLanguage, setTextAreaValue, setIsRecordingInProcess, isTrascribe, setRunOnValue]);

  // Return the functions from the voiceService
  return [
    voiceService.stopStreaming.bind(voiceService),
    voiceService.startStreaming.bind(voiceService),
    voiceService.deleteStreaming.bind(voiceService),
    voiceService.connectToWhisper.bind(voiceService),
    voiceService.pauseStreaming.bind(voiceService),
    voiceService.getSocketState.bind(voiceService)
  ] as const;
};
